import type { SVGProps } from "react";
export interface RvIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function RvIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: RvIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M15.043 16.875a1.126 1.126 0 0 1 0 2.25H8.946a1.125 1.125 0 0 1 0-2.25zM.875 15V6A4.125 4.125 0 0 1 5 1.875h13.72c.914 0 1.718.583 2.01 1.436l.05.174.5 2 .049.25a2.126 2.126 0 0 1-1.452 2.284l.984 1.72 1.414 1.061.19.161c.419.399.66.954.66 1.538V15a4.13 4.13 0 0 1-2.861 3.927 1.125 1.125 0 1 1-.689-2.141 1.88 1.88 0 0 0 1.3-1.786v-2.438l-1.25-.937h-5.126a1.126 1.126 0 0 1-1.113-.965l-.5-3.501A1.126 1.126 0 0 1 14 5.875h5.06l-.438-1.75H5c-1.036 0-1.875.84-1.875 1.875v9c0 .814.52 1.51 1.25 1.768a1.125 1.125 0 0 1-.75 2.123A4.13 4.13 0 0 1 .875 15m9.626-9.125.205.018c.466.086.838.463.908.948l.5 3.5A1.126 1.126 0 0 1 11 11.624H6A1.125 1.125 0 0 1 4.875 10.5V7c0-.62.504-1.125 1.125-1.125zm4.976 3.5h2.584l-.714-1.25h-2.05zm-8.352 0h2.579l-.18-1.25h-2.4z"
      />
      <path
        fill={color}
        d="M7.875 18.5a1.375 1.375 0 1 0-2.75 0 1.375 1.375 0 0 0 2.75 0m11 0a1.376 1.376 0 1 0-2.751.001 1.376 1.376 0 0 0 2.752 0Zm-8.75 0a3.624 3.624 0 1 1-7.249 0 3.624 3.624 0 0 1 7.248 0Zm11 0a3.625 3.625 0 1 1-7.25-.001 3.625 3.625 0 0 1 7.25.002Z"
      />
    </svg>
  );
}
